export default [
  {
    header: 'pages.mainVerticalMenu.pages',
    resource: ['pages', 'pageCategories'],
    action: 'read',
  },
  {
    title: 'pageCategories.mainVerticalMenu.pageCategories',
    icon: 'LayersIcon',
    resource: 'pageCategory',
    action: 'read',
    children: [
      {
        title: 'pageCategories.mainVerticalMenu.pageCategoriesList',
        route: 'pages-page-categories-list',
        resource: 'pageCategory',
        action: 'read',
      },
      {
        title: 'pageCategories.mainVerticalMenu.pageCategoryAdd',
        route: 'pages-page-categories-add',
        resource: 'pageCategory',
        action: 'create',
      },
    ],
  },
  {
    title: 'pages.mainVerticalMenu.pages',
    icon: 'LayoutIcon',
    resource: 'page',
    action: 'read',
    children: [
      {
        title: 'pages.mainVerticalMenu.pagesList',
        route: 'pages-pages-list',
        resource: 'page',
        action: 'read',
      },
      {
        title: 'pages.mainVerticalMenu.pageAdd',
        route: 'pages-pages-add',
        resource: 'page',
        action: 'create',
      },
    ],
  },
]
